import { getCurrentJwt } from "../../../util/jwt/decryptToken"
import CryptoJS from 'crypto-js'

export async function startChatQuery(messages, newInput, clientName,signal) {
  // Configure Input Params
  let currMessages = messages.concat([{
    role: "user",
    content: newInput
  }])

  let cmpUser;
  try {
    cmpUser =  JSON.parse(
      CryptoJS.AES.decrypt(
        localStorage.getItem("email"),
        process.env.REACT_APP_PASS
      ).toString(CryptoJS.enc.Utf8)
    )
  }
  catch(_) {
    cmpUser = ""
  }
  if(!cmpUser) {
    cmpUser = ""
  }

  let options = {
    method: "PUT",
    signal: signal,
    headers: {
      Authorization: getCurrentJwt()
    },
    body: JSON.stringify({
      messages: currMessages,
      clientName: clientName,
      cmpUser: cmpUser
    })
  }

  let sleepTime = 500
  let res = null
  const initalTime = Date.now()
  const currTimeout = 15000 // 15 Seconds

  // Signals for Abort
  const testAbort1 = new RegExp(".*AbortError: signal is aborted without reason.*")
  const testAbort2 = new RegExp(".*The operation was aborted.*")
  const testAbort3 = new RegExp(".*aborted.*")

  // Main While Loop
  while((Date.now() - initalTime) < currTimeout) {
    try {
      // Fetch Data
      res = await fetch(process.env.REACT_APP_API +"/orion/chat", options)

      // Handle Auth Error
      if(res.status === 401) {
        window.location = '/login'
      }
      // Handle Valid Request
      else if(res.status === 200) {
        res = JSON.parse(await res.json())
        if(res.hasOwnProperty('messages')) {
          const uuidv4 = require("uuid/v4");
          res.messages[0].uuid = uuidv4()
          return res.messages
        }
      }
      // Sleep if otherwise
      // sleepTime *= 2
      await new Promise(resolve => setTimeout(resolve, sleepTime));
    }
    catch(e) {
      // Handle Abort
      if(testAbort1.test(e.toString()) || testAbort2.test(e.toString()) || testAbort3.test(e.toString())) {
        return [{"role": "assistant", "content": "Request Canceled"}]
      }
      console.log(e)
      // Sleep if Other Error
      // sleepTime *= 2
      await new Promise(resolve => setTimeout(resolve, sleepTime));
    }
  }

  // Return Timeout Error handle
  return [{"role": "assistant", "content": "Whoops! Something went wrong. Please refresh your browser and try again."}]
}


// WEBPACK FOOTER //
// ./src/views/ChatPage/chatPageUtil/startChatQuery.js